import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-relative tw-top-0 tw-left-0"
}
const _hoisted_2 = { class: "tw-absolute tw-top-[8px] tw-left-[22px]" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "tw-pl-4" }
const _hoisted_6 = { class: "tw-pl-4" }
const _hoisted_7 = { class: "tw-pl-4" }
const _hoisted_8 = { class: "sf-table" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "!tw-pl-6" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 0,
  class: "tw-text-center"
}
const _hoisted_17 = {
  key: 0,
  class: "tw-inline-block tw-px-4"
}
const _hoisted_18 = {
  key: 1,
  class: "tw-inline-block tw-px-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DbMathLevelItem = _resolveComponent("DbMathLevelItem", true)!
  const _component_SfRouterLink = _resolveComponent("SfRouterLink")!
  const _component_StudentResultSummary = _resolveComponent("StudentResultSummary")!
  const _component_SfAccordion = _resolveComponent("SfAccordion")!

  return (_ctx.levels.length > 0)
    ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
        _createElementVNode("div", {
          class: "sf-accordion-head",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.expanded = !_ctx.expanded), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.expanded)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "-"))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, "+"))
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.category.name) + " (" + _toDisplayString(_ctx.yearLabel) + ") ", 1)
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_SfAccordion, {
            show: _ctx.expanded,
            onTranstionend: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('resized')))
          }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subCategories, (c) => {
                  return (_openBlock(), _createBlock(_component_DbMathLevelItem, {
                    key: c.id,
                    category: c,
                    "all-categories": _ctx.allCategories,
                    "all-levels": _ctx.allLevels,
                    students: _ctx.students,
                    "teacher-mode": _ctx.teacherMode,
                    "current-user": _ctx.currentUser,
                    "default-year": _ctx.year,
                    "hide-empty": true
                  }, null, 8, ["category", "all-categories", "all-levels", "students", "teacher-mode", "current-user", "default-year"]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("table", _hoisted_8, [
                  _createElementVNode("tbody", null, [
                    (_ctx.teacherMode)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                          _hoisted_10,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeStudentIds, (sid) => {
                            return (_openBlock(), _createElementBlock("td", { key: sid }, _toDisplayString(_ctx.students[sid].fullName), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.levels, (lvl) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: lvl.id
                      }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", null, [
                              (!_ctx.teacherMode)
                                ? (_openBlock(), _createBlock(_component_SfRouterLink, {
                                    key: 0,
                                    to: '/maths/level/' + lvl.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(lvl.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(lvl.name), 1))
                            ]),
                            (lvl.subLevels && lvl.subLevels.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createElementVNode("a", {
                                    href: "",
                                    onClick: _withModifiers(($event: any) => (lvl.expanded = !lvl.expanded), ["prevent"])
                                  }, " + " + _toDisplayString(lvl.sublevels_expand_label || 'smaller steps'), 9, _hoisted_13)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeStudentIds, (sid) => {
                            return (_openBlock(), _createElementBlock("td", { key: sid }, [
                              (lvl.studentResultSummary)
                                ? (_openBlock(), _createBlock(_component_StudentResultSummary, {
                                    key: 0,
                                    summary: lvl.studentResultSummary[sid]
                                  }, null, 8, ["summary"]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]),
                        (lvl.expanded)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(lvl.subLevels, (sublvl) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: sublvl.id
                              }, [
                                _createElementVNode("td", _hoisted_14, [
                                  (!_ctx.teacherMode)
                                    ? (_openBlock(), _createBlock(_component_SfRouterLink, {
                                        key: 0,
                                        to: '/maths/level/' + sublvl.id
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(sublvl.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(sublvl.name), 1))
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeStudentIds, (sid) => {
                                  return (_openBlock(), _createElementBlock("td", { key: sid }, [
                                    (sublvl.studentResultSummary)
                                      ? (_openBlock(), _createBlock(_component_StudentResultSummary, {
                                          key: 0,
                                          summary: sublvl.studentResultSummary[sid]
                                        }, null, 8, ["summary"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            }), 128))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ])
              ]),
              (_ctx.showYearPaging)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (_ctx.prevYear)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("a", {
                            href: "",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.currentYear = _ctx.prevYear), ["prevent"]))
                          }, " < Easier ")
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.nextYear)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("a", {
                            href: "",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.currentYear = _ctx.nextYear), ["prevent"]))
                          }, " Harder > ")
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["show"])
        ])
      ]))
    : _createCommentVNode("", true)
}